<template>
  <div class="inquiry-apply-list-page">
    <section class="list-section search-section">
      <Search :is-type="isType" :isShow="false" @searchData="searchData"></Search>
    </section>

    <section class="list-section table-section">
      <el-tabs class="list-tabs" @tab-click="handleClick" v-model="activeName">
        <el-tab-pane
          v-for="item in countCards"
          :key="item.key"
          :label="`${item.label}(${countText(allcount[item.countKey])})`"
          :name="item.key"></el-tab-pane>
      </el-tabs>

      <div
        ref="tableWrap"
        class="table-wrap"
        v-loading="loading"
        element-loading-text="加载中……"
        element-loading-spinner="el-icon-loading">
        <el-table :data="tableData" class="inquiry-table" :height="tableBodyHeight" style="width: 100%">
          <el-table-column align="center" label="序号" type="index" width="58"></el-table-column>

          <el-table-column label="项目名称" min-width="320" show-overflow-tooltip>
            <template slot-scope="{row}">
              <div class="project-cell">
                <div class="project-name-line">
                  <el-link
                    v-if="userPermissions.indexOf('inquiry_apply_detail') !== -1"
                    class="project-link"
                    :title="row.name || '-'"
                    @click="detailPage(row.id)">
                    {{ row.name || '-' }}
                  </el-link>
                  <span v-else class="project-name" :title="row.name || '-'">{{ row.name || '-' }}</span>
                </div>
                <div class="project-sub" v-if="formatIntentions(row.intentions)">
                  意向达人: {{ formatIntentions(row.intentions) }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="品牌" min-width="100" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span class="primary-text">{{ row.brand || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="已报" min-width="90">
            <template slot-scope="{row}">
              <span>{{ countText(row.mine_count) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="合作平台" min-width="320">
            <template slot-scope="{row}">
              <el-tooltip
                v-if="formatPlatforms(row.platforms).length"
                :content="formatPlatforms(row.platforms).join('、')"
                placement="top">
                <div class="platform-list">
                  <span
                    v-for="platform in formatPlatforms(row.platforms).slice(0, 3)"
                    :key="platform"
                    class="platform-chip">
                    {{ platform }}
                  </span>
                  <span v-if="formatPlatforms(row.platforms).length > 3" class="platform-more">...</span>
                </div>
              </el-tooltip>
              <span v-else class="muted">-</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="合作形式" min-width="100">
            <template slot-scope="{row}">
              <span>{{ row.coop ? row.coop.display_name : '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="档期" width="220" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span class="date-range">{{ formatDateRange(row.expect_start, row.except_end) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="报名截止日期" width="150" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span class="date-range" :class="{'date-urgent': isDateUrgent(row)}">{{ formatApplyDeadline(row) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" fixed="right" label="操作" width="116">
            <template slot-scope="{row}">
              <el-button
                v-if="userPermissions.indexOf('inquiry_apply_detail') !== -1"
                type="primary"
                size="mini"
                :icon="activeName === 'able' ? 'el-icon-circle-check' : 'el-icon-view'"
                @click="detailPage(row.id)">
                {{ activeName === 'able' ? '报名' : '查看' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div ref="paginationWrap" class="pagination-wrap">
          <Pagination
            :limit.sync="tablePagination.page_size"
            :page.sync="tablePagination.current_page"
            :total="tablePagination.total"
            @pagination="infoData" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Search from './components/search'
import { mapGetters } from 'vuex'

export default {
  name: 'inquiryApplyList',
  components: { Search },
  data() {
    return {
      tableData: [],
      drawerVisible: false,
      loading: false,
      rowId: 'add',
      activeName: 'mine',
      tableBodyHeight: 360,
      tablePagination: {
        total: 0,
        page_size: 15,
        offset: 0,
        current_page: 1
      },
      allcount: {
        able_count: null,
        mine_count: null,
        employ_count: null,
        confirm_count: null
      },
      searchDatas: {},
      isType: true
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    countCards() {
      return [
        { key: 'able', label: '可报名', countKey: 'able_count' },
        { key: 'mine', label: '我的报名', countKey: 'mine_count' },
        { key: 'employ', label: '已初选', countKey: 'employ_count' },
        { key: 'confirm', label: '已合作', countKey: 'confirm_count' }
      ]
    }
  },
  // watch: {
  //   drawerVisible: {
  //     handler(val) {
  //       if (!val) {
  //         this.infoData()
  //       }
  //     }
  //   }
  // },
  methods: {
    handleClick() {
      this.infoData()
    },
    updateTableLayout() {
      this.$nextTick(() => {
        const tableWrap = this.$refs.tableWrap
        const paginationWrap = this.$refs.paginationWrap
        if (!tableWrap) {
          return
        }
        const nextTableHeight = Math.max(
          220,
          tableWrap.clientHeight - (paginationWrap ? paginationWrap.offsetHeight : 0)
        )
        if (nextTableHeight !== this.tableBodyHeight) {
          this.tableBodyHeight = nextTableHeight
        }
      })
    },
    bindTableLayout() {
      if (this.tableResizeObserver) {
        return
      }
      if (typeof ResizeObserver !== 'undefined' && this.$refs.tableWrap) {
        this.tableResizeObserver = new ResizeObserver(() => {
          this.updateTableLayout()
        })
        this.tableResizeObserver.observe(this.$refs.tableWrap)
      }
      window.addEventListener('resize', this.updateTableLayout)
    },
    unbindTableLayout() {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
      window.removeEventListener('resize', this.updateTableLayout)
    },
    searchData(val) {
      const cond = {}
      const name = [
        'name',
        'status',
        'brand',
        'created_by',
        'product_non_fuzzy',
        'created_start',
        'created_end',
        'expect_start',
        'expect_end',
        'is_apply',
        'is_confirm'
      ]
      name.forEach((type) => {
        if (this.hasValue(val[type])) {
          cond[type] = val[type]
        }
      })
      if (val.intentions?.length) {
        cond['intentions'] = val.intentions
      }
      if (val.platforms?.length) {
        cond['platforms'] = val.platforms
      }
      this.searchDatas = cond
      this.tablePagination.current_page = 1
      this.infoData()
    },

    async infoData() {
      this.loading = true
      const searchCondition = {
        ...this.searchDatas,
        page_size: this.tablePagination.page_size || 15,
        current_page: this.tablePagination.current_page || 1,
        case_type: this.activeName,
        type: this.isType ? 1 : 2
      }
      try {
        const { list = [], page_info } = await this.$api.listApplyInquiry(searchCondition)
        const convertData = ['is_assign', 'is_platform_pay', 'is_send_back', 'is_cart', 'is_auth_price']
        list.forEach((item) => {
          convertData.forEach((i) => {
            if (i === 'is_assign' || i === 'is_send_back') {
              item[i] = item[i] == 1 ? '是' : '否'
            } else item[i] = item[i] == 1 ? '否' : '是'
          })
        })
        this.tableData = list
        this.tablePagination = page_info || this.tablePagination
      } catch (error) {
        this.tableData = []
        this.$message.error('加载询单列表失败')
      } finally {
        this.loading = false
      }
    },
    async handleVoid(rowId) {
      // "status": 2 //1:进行中 2:已完结 3:已作废
      const statusData = {
        id: rowId,
        status: 3
      }
      const id = await this.$api.switchInquiryStatus(statusData)
      if (id) {
        this.$notify.success('作废成功')
        await this.infoData()
      }
    },
    detailPage(id) {
      this.$router.push({
        name: 'enrollDetail',
        params: { id: id }
      })
    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },
    async getCountData() {
      this.allcount = await this.$api.applyCount({ type: 1 })
    },
    hasValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return value !== undefined && value !== null && value !== ''
    },
    countText(value) {
      return value === undefined || value === null ? '-' : value
    },
    formatDate(value) {
      return value ? String(value).slice(0, 10) : '-'
    },
    formatDateRange(start, end) {
      const startText = this.formatDate(start)
      const endText = this.formatDate(end)
      if (startText === '-' && endText === '-') {
        return '-'
      }
      return `${startText} 至 ${endText}`
    },
    formatApplyDeadline(row) {
      return this.formatDate(
        row.apply_end ||
        row.enroll_end ||
        row.apply_deadline ||
        row.enroll_deadline ||
        row.deadline ||
        row.except_end
      )
    },
    isDateUrgent(row) {
      const endText = this.formatApplyDeadline(row)
      if (endText === '-' || !endText) {
        return false
      }
      const end = new Date(endText.replace(/-/g, '/'))
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      end.setHours(0, 0, 0, 0)
      const diffDays = Math.round((end - today) / 86400000)
      return diffDays >= 0 && diffDays <= 3
    },
    formatTextList(value, labelKeys = ['display_name', 'nickname', 'name', 'label', 'value']) {
      if (Array.isArray(value)) {
        return value.map((item) => {
          if (!item || typeof item !== 'object') {
            return item
          }
          const key = labelKeys.find(labelKey => this.hasValue(item[labelKey]))
          return key ? item[key] : ''
        }).filter(Boolean)
      }
      if (typeof value === 'string') {
        return value.split(/[,，、/]/).map(item => item.trim()).filter(Boolean)
      }
      if (value && typeof value === 'object') {
        return this.formatTextList(Object.values(value), labelKeys)
      }
      return []
    },
    formatPlatforms(platforms) {
      return this.formatTextList(platforms, ['display_name', 'platform_name', 'name', 'label', 'value'])
    },
    formatIntentions(intentions) {
      return this.formatTextList(intentions, ['nickname', 'display_name', 'name']).join('、')
    },
    formatAuthPlatforms(platforms) {
      const list = this.formatTextList(platforms, ['display_name', 'platform_name', 'name', 'label', 'value'])
      return list.length ? list.join('、') : '-'
    },
    formatCreator(value) {
      const list = this.formatTextList(value, ['nickname', 'display_name', 'name'])
      return list.length ? list.join('、') : '-'
    },
    formatEnrollers(value) {
      if (Array.isArray(value)) {
        return value.map((item) => {
          if (!item) {
            return ''
          }
          if (typeof item === 'string') {
            return item
          }
          if (typeof item === 'object') {
            return item.nickname || item.display_name || item.name || item.value || ''
          }
          return String(item)
        }).filter(Boolean).join('、')
      }
      if (typeof value === 'string') {
        return value
      }
      return this.formatCreator(value)
    },
    formatYesNo(value) {
      if (value === '是' || value === '否') {
        return value
      }
      if (value === 1 || value === '1' || value === true) {
        return '是'
      }
      if (value === 0 || value === '0' || value === false) {
        return '否'
      }
      return value || '-'
    },
    statusText(status) {
      const map = { 1: '进行中', 2: '已结束', 3: '已作废', 4: '已完结' }
      return map[Number(status)] || '-'
    },
    statusTagType(status) {
      const map = { 1: 'success', 2: 'info', 3: 'danger', 4: 'warning' }
      return map[Number(status)] || 'info'
    },
    applyStatusText(status) {
      if (status === undefined || status === null || status === '') {
        return '-'
      }
      const map = { 1: '报名中', 2: '不可报名', 3: '结束报名' }
      return map[Number(status)] || '-'
    },
    applyTagType(status) {
      const map = { 1: 'success', 2: 'info', 3: 'warning' }
      return map[Number(status)] || 'info'
    },
    confirmStatusText(status) {
      if (status === undefined || status === null || status === '') {
        return '-'
      }
      const map = { 1: '已确认', 0: '未确认' }
      return map[Number(status)] || (status === '已确认' ? '已确认' : '未确认')
    },
    confirmTagType(status) {
      if (status === undefined || status === null || status === '') {
        return 'info'
      }
      return Number(status) === 1 ? 'success' : 'info'
    }
  },
  mounted() {
    this.infoData()
    this.getCountData()
    this.$nextTick(() => {
      this.updateTableLayout()
      this.bindTableLayout()
    })
  },
  beforeDestroy() {
    this.unbindTableLayout()
  }
}
</script>

<style lang="scss" scoped>
.inquiry-apply-list-page {
  --list-accent: #ff3176;
  --list-accent-soft: rgba(255, 49, 118, 0.10);
  padding: 10px;
  height: 100%;
  overflow: hidden;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.list-section {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.05);
}

.search-section {
  padding: 14px 16px 0;
}

.table-section {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.table-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

::v-deep .inquiry-table {
  flex: 0 0 auto;
}

::v-deep .search-section .el-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
}

::v-deep .search-section .el-form-item {
  margin: 0 0 10px;
}

::v-deep .search-section .el-input__inner,
::v-deep .search-section .el-cascader .el-input__inner {
  height: 32px;
  border-color: #e3e8f2;
  border-radius: 6px;
  background: #f8fafc;
}

::v-deep .search-section .el-input__inner:focus {
  border-color: var(--list-accent);
  background: #fff;
}

::v-deep .search-section hr {
  display: none;
}

::v-deep .search-section .el-button--primary,
::v-deep .table-section .el-button--primary {
  border: none;
  border-radius: 8px;
  background: var(--list-accent);
  box-shadow: 0 6px 14px rgba(255, 49, 118, 0.20);
}

::v-deep .list-tabs .el-tabs__header {
  margin: 0 0 12px;
}

::v-deep .list-tabs .el-tabs__nav-wrap::after {
  height: 1px;
  background: #edf1f7;
}

::v-deep .list-tabs .el-tabs__item {
  color: #667085;
  font-weight: 600;
}

::v-deep .list-tabs .el-tabs__item.is-active {
  color: var(--list-accent);
}

::v-deep .list-tabs .el-tabs__active-bar {
  background: var(--list-accent);
}

::v-deep .inquiry-table {
  color: #334155;
  font-size: 13px;
}

::v-deep .inquiry-table::before {
  display: none;
}

::v-deep .inquiry-table th.el-table__cell {
  background: #f8fafc;
  color: #8793a8;
  font-weight: 700;
}

::v-deep .inquiry-table thead th .cell,
::v-deep .inquiry-table thead th.is-leaf .cell {
  height: 30px !important;
  line-height: 30px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #8793a8 !important;
}

::v-deep .inquiry-table td.el-table__cell,
::v-deep .inquiry-table th.el-table__cell {
  border-bottom: 1px solid #edf1f7;
}

::v-deep .inquiry-table .el-table__fixed-right::before {
  display: none;
}

.project-cell,
.stack-cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.project-name-line {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.project-link,
.project-name {
  color: #ff3176;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.primary-text {
  color: #0f172a;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-link {
  max-width: 100%;
}

.project-sub,
.sub-text,
.muted {
  color: #8a96ab;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assign-text {
  flex: 0 0 auto;
}

.meta-line {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.5;
}

.meta-line-compact {
  align-items: center;
}

.meta-label {
  flex: 0 0 72px;
  color: #8a96ab;
  font-size: 12px;
  white-space: nowrap;
}

.meta-value {
  min-width: 0;
  flex: 1;
  color: #334155;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assign-tag {
  border: none;
  background: #ffe9f1;
  color: #ff3176;
  flex: 0 0 auto;
}

.platform-list,
.requirement-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.meta-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px 10px;
}

.platform-chip {
  height: 26px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #e3e8f2;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
}

.platform-more {
  height: 26px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  background: #fff0f5;
  color: #ff3176;
  font-size: 13px;
  font-weight: 700;
  line-height: 24px;
}

.requirement-item {
  height: 24px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  background: #f1f5f9;
  color: #526070;
  font-size: 12px;
  line-height: 24px;
}

.requirement-item.highlight {
  background: #ffe9f1;
  color: var(--list-accent);
}

.status-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.date-range {
  color: #475569;
  font-weight: 600;
}

.date-range.date-urgent {
  color: #ec6b6b;
}

.pagination-wrap {
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 1200px) {
  .list-section {
    padding: 12px;
  }
}
</style>
